import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import HeaderOne from "../components/HeaderOne";
import BannerThree from "../components/BannerThree";
import PromotionalThree from "../components/PromotionalThree";
import FeatureThree from "../components/FeatureThree";
import TextSlider from "../components/TextSlider";
import TrendingThree from "../components/TrendingThree";
import DiscountThree from "../components/DiscountThree";
import NewArrivalThree from "../components/NewArrivalThree";
import DealsSection from "../components/DealsSection";
import PopularProductsThree from "../components/PopularProductsThree";
import BrandThree from "../components/BrandThree";
import ShippingOne from "../components/ShippingOne";
import TestimonialOne from "../components/TestimonialOne";
import InstagramSection from "../components/InstagramSection";
import NewsletterThree from "../components/NewsletterThree";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";

const HomePageThree = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      

      {/* Preloader */}
      <Preloader />

      {/* HeaderOne */}
      <HeaderOne />

      {/* BannerThree */}
      <BannerThree />

      {/* PromotionalThree */}
      <PromotionalThree />

      {/* FeatureThree */}
      <FeatureThree />

      {/* TextSlider */}
      <TextSlider />

      {/* TrendingThree */}
      <TrendingThree />

      {/* DiscountThree */}
      <DiscountThree />

      {/* NewArrivalThree */}
      <NewArrivalThree />

      {/* DealsSection */}
      <DealsSection />

      {/* PopularProductsThree */}
      <PopularProductsThree />

      {/* BrandThree */}
      <BrandThree />

      {/* ShippingOne */}
      <ShippingOne />

      {/* TestimonialOne */}
      <TestimonialOne />

      {/* InstagramSection */}
      <InstagramSection />

      {/* NewsletterThree */}
      <NewsletterThree />

      {/* FooterOne */}
      <FooterOne />
      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default HomePageThree;
